import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { FlowType } from '@enmon/commons/lib/enmon';

export const FLOW_TYPE_TRANSLATED = defineMessages<FlowType>({
  [FlowType.Import]: {
    id: 'app.common.supplyPoint.flowType.import',
  },
  [FlowType.Export]: {
    id: 'app.common.supplyPoint.flowType.export',
  },
  [FlowType.Bidirectional]: {
    id: 'app.common.supplyPoint.flowType.bidirectional',
  },
  [FlowType.Generator]: {
    id: 'app.common.supplyPoint.flowType.generator',
  },
});
